/**
 * Different buttons that can be displayed on the @see MapToolbarComponent
 */

export enum ToolbarButton {
    MeasurementLine,
    MeasurementRadius,
    Delete
}
